module.exports = __webpack_public_path__ + "img/lux map icon offline.dcb6d4c9.png";